<template>
  <div>
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <Header />
    <Notification />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Notification from "@/components/Notification";
import Header from "@/views/index/header.vue";
import Footer from "@/views/index/footer.vue";
import Common from "@/utils/Common";
import './main.less';
import './layout.less';
// import Index from './views/index/index.vue'

const langMap = {
	"ko":"kr", "zh-CN":"zh-CN","zh-TW":"zh-CN", "en":"en", "zh":"zh-CN", "kr":"kr" , "fr":"fr", "po":"po"
}

export default {
  name: 'App',
  components: {
    Notification,
    Header,
    Footer
  },
  created(){
    let lang = 'en';
		let storageLang = Common.getUrlParams('lang') || Common.getStorageItem("lang")
		
		if(storageLang){
			lang = langMap[storageLang] || 'en'
		}else{
			lang = navigator.language||navigator.userLanguage;
			lang = langMap[lang] || 'en';
		}
		Common.setStorageItem("lang", lang)

		// let lang = Common.getStorageItem("lang") || "en";
		// this.defaultSelectLangPos = this.langNameToPos.indexOf(lang);
		this.$i18n.locale = lang;
  }
}
</script>

<style>
  body{
    margin: 0px!important;
    overflow-x: hidden;
  }

  .no-scroll{
    overflow: hidden;
  }

  * {
    padding: 0;
    margin: 0;
    font-family: Poppins,微软雅黑;
    box-sizing: border-box;
  }
</style>
